
export function bytesToHuman(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export function filenameToIcon(filename){

    const DEFAULT = 'doc';
    const ALLOWED = [DEFAULT, 'pdf', 'psd'];
    let icon = filename ? filename.replace(/.*?\.(\w+)$/gm, '$1').toLowerCase():'doc';
    if(!ALLOWED.includes(icon)) icon = DEFAULT;
    return `assets/theme/images/icon/${icon}.png`;
}